function SupportedMetaverseList(props) {
    return (
        <div>
            <div className="mb-10">
                <div className="flex items-center">
                    <div className="uppercase font-bold tracking-widest">Metaverses We Support</div>
                    <div className="flex-grow h-0 ml-3 border-solid border-b border-grey"></div>
                </div>
            </div>
            <ul className="flex justify-between" role="list">
                {props.children}
            </ul>
        </div>
    );
}

export default SupportedMetaverseList;